import { ref, watch, onUnmounted, type Ref } from 'vue'
import { useRouter } from 'vue-router'

export type RouterState = Record<string, unknown>

/**
 * Composable to access the current router state object reactively
 */
export const useRouterState = (): Ref<RouterState> => {
  const router = useRouter()
  const routerState = ref<RouterState>(router?.options?.history.state || {})

  const updateState = () => {
    routerState.value = router?.options?.history.state || {}
  }

  // Listen to route changes to update the state
  const unwatch = watch(() => router?.currentRoute?.value, updateState, {
    immediate: true,
  })

  // Cleanup the watcher when the composable is no longer needed
  onUnmounted(() => {
    unwatch()
  })

  return routerState
}
